import React, { SVGProps } from 'react'

import MeasurIcon from './MeasurIcon'

export default class IconCircledCheck extends MeasurIcon<
  SVGProps<SVGSVGElement>
> {
  render() {
    return (
      <svg width="20" height="20" viewBox="0 0 512 512" {...this.props}>
        <circle cx="256" cy="256" r="256" fill="#185ef2" />
        <line
          x1="152.283"
          y1="256.277"
          x2="225.277"
          y2="330.717"
          stroke="#fff"
          strokeWidth="40"
          strokeLinecap="round"
        />
        <line
          x1="360.417"
          y1="181.249"
          x2="226.249"
          y2="329.583"
          stroke="#fff"
          strokeWidth="40"
          strokeLinecap="round"
        />
      </svg>
    )
  }
}
